import { GlobalStyles } from './styles/globalStyles'
import AppProvider from './context'
import { BrowserRouter } from 'react-router-dom'
import Routes from './routes/index'
import { Toast } from 'src/components/Toast'
import Modal from 'react-modal'
import './utils/yupCustomMethods'

Modal.setAppElement('#root')

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <Routes />
        </AppProvider>
        <GlobalStyles />
        <Toast />
      </BrowserRouter>
    </div>
  );
}

export default App;
